import * as wrapActions from "./wrap-actions"

export default function EditorAutosuggestSnippetsPlugin() {
  return {
    statePlugins: {
      editor: {
        wrapActions,
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/editor-autosuggest-snippets/index.js